export default {"src":"/_next/static/media/server.7dc793ee.svg","height":51,"width":50,"blurWidth":0,"blurHeight":0};